import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
`

export const categoryLabel = css`
  ${font_md};
  font-weight: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  margin-bottom: ${spacing(2)};
  display: flex;
`

export const categoryValue = css`
  ${font_lg};
  font-weight: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
`

export const automationIcon = css`
  margin-left: ${spacing(1)};
  align-self: flex-start;
`
